module.exports = __webpack_public_path__ + "img/PL08185.a31ec94c.png";